import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Text, mergeStyleSets } from '@fluentui/react';
import { getPriceWithFrequencyText } from '@shared/utils/pricing';
import { CustomMeterPricing } from '@shared/components';
import FuturePriceTooltip from '@shared/components/futurePriceTooltip';
const classes = mergeStyleSets({
    pricingCellRoot: {
        whiteSpace: 'break-spaces'
    }
});
const SaasPricingContent = ({ sku, price, billingCountry, variant, locale }, context)=>{
    const { countryCode } = billingCountry;
    const priceText = getPriceWithFrequencyText({
        context,
        priceObject: price,
        isQuantifiable: sku.isQuantifiable,
        countryCode,
        currency: sku.currencyCode,
        maximumFractionDigits: 2,
        onetimePaymentTranslation: 'Pricing_Onetime_Payment',
        locale
    });
    const freeTrialText = price.freeDurationDays ? context.loc('First_Month_Free_Trial', 'First month free, then ') : ''; // SaaS offers can only have 30 days(1 month) trial
    const fullPricingText = `${freeTrialText}${priceText}`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                variant: variant,
                children: fullPricingText
            }),
            /*#__PURE__*/ _jsx(CustomMeterPricing, {
                sku: sku,
                billingCountry: billingCountry,
                price: price,
                variant: variant,
                locale: locale
            })
        ]
    });
};
export const SaasPricingCell = ({ sku, futurePriceSku, price, billingCountry, shouldBlockPrices, locale }, context)=>{
    var _futurePriceSku_termPrices;
    if (shouldBlockPrices) {
        return /*#__PURE__*/ _jsx(Text, {
            children: context.loc('Pricing_ContactPublisher', 'Contact the publisher for pricing information and to purchase the license')
        });
    }
    const futurePriceTerm = futurePriceSku === null || futurePriceSku === void 0 ? void 0 : (_futurePriceSku_termPrices = futurePriceSku.termPrices) === null || _futurePriceSku_termPrices === void 0 ? void 0 : _futurePriceSku_termPrices.find((futurePriceTerm)=>futurePriceTerm.termId === price.termId);
    return /*#__PURE__*/ _jsxs("div", {
        className: classes.pricingCellRoot,
        children: [
            /*#__PURE__*/ _jsx(SaasPricingContent, {
                sku: sku,
                price: price,
                billingCountry: billingCountry,
                locale: locale
            }),
            futurePriceTerm && /*#__PURE__*/ _jsx(FuturePriceTooltip, {
                futurePrice: {
                    priceComponent: /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(SaasPricingContent, {
                            sku: futurePriceSku,
                            price: futurePriceTerm,
                            billingCountry: billingCountry,
                            variant: "small",
                            locale: locale
                        })
                    }),
                    startDate: futurePriceSku.startDate
                }
            })
        ]
    });
};
SaasPricingCell.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
SaasPricingContent.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
